import React from 'react';

const FALLBACK_IMG = '/static/weeklydefense_theme.png';

const ArticleCard = ({ article, onClick, formatDate, truncateText, onCardClick }) => {
  const imageUrl = article.banner_image_url
    || (article.images && article.images[0])
    || FALLBACK_IMG;

  const title = article.title;
  const summary = article.summary;
  const sourceName = article.source_name;

  const handleClick = async () => {
    if (onCardClick) {
      await onCardClick(article.id);
    }
    onClick(article);
  };

  const handleImageError = (e) => {
    if (e.target.src.endsWith(FALLBACK_IMG)) return;
    e.target.src = FALLBACK_IMG;
  };

  return (
    <div className="article-card" onClick={handleClick}>
      <div className="card-image">
        <img 
          src={imageUrl} 
          alt={title}
          onError={handleImageError}
        />
        <span className="card-source-badge">{sourceName}</span>
      </div>
      <div className="card-content">
        <div className="card-meta">
          <span className="card-date">{formatDate(article.scraped_at)}</span>
          {article.reading_time && (
            <span className="card-reading-time">{article.reading_time} min read</span>
          )}
        </div>
        <h3 className="card-title">{title}</h3>
        <p className="card-summary">{truncateText(summary, 120)}</p>
        <div className="card-footer">
          <span className="read-more">Read Summary →</span>
          {article.click_count > 0 && (
            <span className="click-count">{article.click_count} views</span>
          )}
        </div>
      </div>
    </div>
  );
};
export default ArticleCard;